import React from 'react';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { useV2TableComponents } from './useV2TableComponents';

/**
 * Chooses between legacy and V2 table tool implementations.
 */
const createSwitchableTableComponent =
    <Props extends { element?: ImMNElement }>(
        LegacyComponent: React.ComponentType<Props>,
        V2Component: React.ComponentType<Props>,
    ): React.FC<Props> =>
    (props) => {
        const Component = useV2TableComponents(props.element) ? V2Component : LegacyComponent;
        const componentProps = props as unknown as Props;

        return <Component {...componentProps} />;
    };

export default createSwitchableTableComponent;
